import { Address } from './vehicle';

/**
 * Represents a booking record.
 */
export interface Booking {
  id?: number;
  vehicle_id?: number;
  loadingPlaces: LoadingPlace[];
  startPlace: LoadingPlace;
  startTime: number;
  endPlace: LoadingPlace;
  endTime: number;
  internal_offer_id?: number;
  externalOfferId?: string;
  status: BookingStatus;
  score?: number;
  createdAt?: Date;
  customerDomain?: string;
  distanceKms?: number;
  price?: number;
  tenant_id?: number;
  updatedOn?: Date;
  delayed?: boolean;
  source?: number;
  approachDistanceKms?: number;
}

export const enum LoadingPlaceTypes {
    LOADING = 'LOADING',
    UNLOADING = 'UNLOADING'
}

export interface LoadingPlace {
    loadingType: LoadingPlaceTypes;
    address: Address;
    startTime: string;
    endTime: string;
    earliestLoadingDate: string;
    latestLoadingDate: string;
    name?: string;
    reference?: string;
    goodsType?: string;
}

export enum BookingStatus {
  CONFIRMED = 1,
  FINISHED = 2,
  CANCELLED = 3,
  IN_PROGRESS = 4
}

export const BookingStatusList = [
  {key: 'Confirmed', value: BookingStatus.CONFIRMED, color: 'primary'},
  {key: 'Finished', value: BookingStatus.FINISHED, color: 'success'},
  {key: 'Cancelled', value: BookingStatus.CANCELLED, color: 'default'},
  {key: 'In Progress', value: BookingStatus.IN_PROGRESS, color: 'warning'}
];
